import styles from './LegalTextStack.module.css';

const LegalTextStack: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => <div className={styles.wrapper}>{children}</div>;

export default LegalTextStack;
